import { render, staticRenderFns } from "./custom-tops-card.vue?vue&type=template&id=a64d07f6&scoped=true"
import script from "./custom-tops-card.vue?vue&type=script&lang=js"
export * from "./custom-tops-card.vue?vue&type=script&lang=js"
import style0 from "./custom-tops-card.vue?vue&type=style&index=0&id=a64d07f6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a64d07f6",
  null
  
)

export default component.exports